import React, { ReactText } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Button, Col, Row } from 'react-bootstrap';
import translate from '../translate';
import { RootState } from '../../store';
import {
    ApaleoPropertyResponseDto,
    LoadApaleoPropertyListForLocation,
    SetApaleoPropertyIdForLocation,
} from '../../store/locationApaleoPropertySlice';
import LeftSide from '../main/left-side';
import TitleCard from '../main/title-card';
import LargeCard from '../main/large-card';
import LocationApaleoPropertyList from './forms/location-apaleo-property-list';
import { goToLocation } from '../../nav/navigationService';
import withParams from '../../nav/withParams';

interface DataProps {
    propertyRequest: ApaleoPropertyResponseDto;
    params: {
        location_id: ReactText;
        object_id: ReactText;
    };
    strings: {
        cancel: string;
        title: string;
        subtitle: string;
        left1: string;
        left2: string;
        pages: string;
    };
}

interface Props extends DataProps {
    LoadApaleoPropertyListForLocation: typeof LoadApaleoPropertyListForLocation;
    SetApaleoPropertyIdForLocation: typeof SetApaleoPropertyIdForLocation;
}

interface State {}

class LocationApaleoPropertyScreen extends React.Component<Props, State> {
    componentDidMount() {
        this.props.LoadApaleoPropertyListForLocation(
            this.props.params.location_id
        );
    }

    componentWillReceiveProps(nextProps: Readonly<Props>) {
        if (nextProps.params.location_id !== this.props.params.location_id) {
            this.props.LoadApaleoPropertyListForLocation(
                nextProps.params.location_id
            );
        }
    }

    render(): React.ReactElement<any> | null {
        const properties = this.props.propertyRequest?.properties || [];

        return (
            <Row>
                <LeftSide>
                    <TitleCard
                        title={[
                            this.props.strings.left1,
                            this.props.strings.left2,
                        ]}
                        left={{
                            content: (
                                <Link
                                    to={`/objects/${this.props.params.object_id}/${this.props.params.location_id}`}
                                    className="icon icon-wew-arrow-left icon-sm"
                                />
                            ),
                            title: this.props.strings.cancel,
                        }}
                    />
                </LeftSide>
                <Col xs={6} sm={6} md={6} lg={6} className="col-middle">
                    <LargeCard
                        type="card-edit"
                        title={[
                            this.props.strings.title,
                            this.props.strings.subtitle,
                        ]}
                    >
                        <LocationApaleoPropertyList
                            properties={properties}
                            onLinkPropertyId={(propertyId) =>
                                this.handleLinkProperty(propertyId)
                            }
                        />
                        {this.maybeRenderPages()}
                    </LargeCard>
                </Col>
            </Row>
        );
    }

    handleLinkProperty = (propertyId: string) => {
        this.props.SetApaleoPropertyIdForLocation(
            this.props.params.location_id,
            propertyId,
            () => this.handleLinkDone()
        );
    };

    handleLinkDone = () => {
        goToLocation(
            this.props.params.object_id,
            this.props.params.location_id
        );
    };

    maybeRenderPages = () => {
        const pageCount = this.props.propertyRequest?.total_pages || 0;
        if (pageCount <= 1) {
            return null;
        }

        const pages = [];
        for (let i = 0; i < pageCount; ++i) {
            pages.push(this.renderLink(i));
        }

        return (
            <div>
                <hr className={'divider'} />
                {this.props.strings.pages}
                {pages}
            </div>
        );
    };

    renderLink = (page: number) => {
        const pageText = String(page + 1);

        const loadPage = () => {
            this.props.LoadApaleoPropertyListForLocation(
                this.props.params.location_id,
                page
            );
        };

        if (page === Number(this.props.propertyRequest?.page)) {
            return <span className={'ml-10 mr-10'}>{pageText}</span>;
        } else {
            return (
                <Button
                    key={`link-to-${pageText}`}
                    onClick={loadPage}
                    className="btn btn-link btn-action ml-10 mr-10"
                >
                    {pageText}
                </Button>
            );
        }
    };
}

export default connect(
    (store: RootState) => ({
        propertyRequest: store.locationApaleoProperty.apaleoPropertyList,
    }),
    { LoadApaleoPropertyListForLocation, SetApaleoPropertyIdForLocation }
)(
    translate('LocationApaleoPropertyScreen')(
        withParams(LocationApaleoPropertyScreen)
    )
);
